import { FeatureFlag } from 'src/types';

export type QuestionFlow = 'default' | 'custom';
export type ReportType = 'misconduct' | 'inquiry';

export interface IntakeChannelsState {
  vaultTalk: boolean;
  slack: boolean;
  reportingPortal: boolean;
}

export interface SpeakUpReportedFieldsValue {
  questionFlow: QuestionFlow;
  reportType: ReportType;
  channels: IntakeChannelsState;
  goTogether: boolean;
  manualIntake?: boolean;
}

export const DEFAULT_REPORTED_FIELDS: SpeakUpReportedFieldsValue = {
  questionFlow: 'default',
  reportType: 'misconduct',
  channels: { vaultTalk: true, slack: true, reportingPortal: true },
  goTogether: true,
  manualIntake: true,
};

// Copy is identical across every entitlement-locked surface (spec §3.7.7).
export const LOCKED_FEATURE_TOOLTIP_COPY =
  'Contact customer support for package updates or to explore add-ons to boost your business efficiency.';

// Feature flags that gate the Custom question flow tab. Either one enables it (OR — matches Forms nav).
export const CUSTOM_FLOW_FEATURE_FLAGS: FeatureFlag[] = [
  FeatureFlag.DYNAMIC_QUESTIONS_V1,
  FeatureFlag.CONFLICT_OF_INTEREST,
];

// Per-channel entitlement flags (spec §2 / design D4).
export const CHANNEL_FEATURE_FLAGS = {
  vaultTalk: FeatureFlag.VAULT_TALK,
  slack: FeatureFlag.SLACK_REPORTING,
  reportingPortal: FeatureFlag.PUBLIC_REPORTING,
} as const;
